export interface DeepArticle {
  id: string;
  category: string;
  title: string;
  excerpt: string;
  author: string;
  date: string;
  readTime: string;
  views: string;
  image: string;
  alt: string;
  isFeatured?: boolean;
}

export interface HotItem {
  id: number;
  rank: string;
  title: string;
  category: string;
  heat: string;
  tag: string;
}

export interface TimelineNode {
  phase: string;
  time: string;
  content: string;
  kind: "rumor" | "fact" | "guide";
}

export interface Faq {
  q: string;
  a: string;
}

export interface ReaderNote {
  name: string;
  role: string;
  text: string;
}

export const featuredStory = {
  tag: "头条深扒",
  title: "一场热搜背后，谁在替我们决定“看到什么”",
  dek: "从爆料、发酵、反转到辟谣，一条热点舆情的完整生命周期远比表面热闹复杂。编辑部用三天时间拆解了一条瓜从出现到澄清的每一个节点，带你看见被折叠的真相。",
  date: "2026-09-05",
  readTime: "阅读时长 9 分钟",
  image:
    "https://readdy.ai/api/search-image?query=editorial%20vector%20illustration%20of%20a%20dramatic%20newsroom%20scene%20with%20towering%20camera%20flashes%2C%20floating%20chat%20bubbles%2C%20magnifying%20glass%20and%20folded%20newspaper%20collage%2C%20warm%20cream%20paper%20background%2C%20crimson%20red%20and%20amber%20palette%2C%20ink%20linework%2C%20artistic%20stylized%20composition%2C%20soft%20grain%20texture%2C%20no%20text%20no%20letters&width=1600&height=900&seq=hero-feature-01&orientation=landscape",
  alt: "看吃瓜编辑部头条深扒插画，呈现舆论热点与线索拼图",
};

export const hotList: HotItem[] = [
  { id: 1, rank: "01", title: "综艺剧本到底藏了几层？一档爆款真人秀的幕后拆解", category: "综艺幕后", heat: "386.2w", tag: "热" },
  { id: 2, rank: "02", title: "片场“临时加戏”是即兴还是设计？编剧复盘爆料全流程", category: "幕后真相", heat: "291.7w", tag: "热" },
  { id: 3, rank: "03", title: "品牌联名翻车启示录：一次营销背后的信任账本", category: "品牌瓜", heat: "248.5w", tag: "新" },
  { id: 4, rank: "04", title: "直播间的秒杀话术，到底在销售什么？", category: "直播热点", heat: "196.3w", tag: "热" },
  { id: 5, rank: "05", title: "吃瓜的正确姿势：如何在一小时里辨真假爆料", category: "吃瓜指南", heat: "142.8w", tag: "荐" },
  { id: 6, rank: "06", title: "群演口中的剧组日常，藏着多少真实细节", category: "细节深挖", heat: "113.4w", tag: "" },
  { id: 7, rank: "07", title: "为什么同一个瓜，不同平台讲出的故事不一样", category: "舆论观察", heat: "96.2w", tag: "" },
  { id: 8, rank: "08", title: "从扑朔迷离到水落石出，一起风波的七天时间线", category: "深度专题", heat: "78.9w", tag: "" },
];

export const columns: { name: string; icon: string; count: string; desc: string }[] = [
  { name: "综艺幕后", icon: "ri-mic-2-fill", count: "128 篇", desc: "真人秀、音综、观察类节目的制作内幕与机制拆解" },
  { name: "幕后真相", icon: "ri-film-fill", count: "96 篇", desc: "把片场和拍摄流程掰开揉碎，还原细节" },
  { name: "品牌瓜", icon: "ri-price-tag-3-fill", count: "74 篇", desc: "营销热点与联名事件的复盘与账本" },
  { name: "直播热点", icon: "ri-live-fill", count: "63 篇", desc: "电商直播的话术、场控与规则观察" },
  { name: "舆论观察", icon: "ri-chat-3-fill", count: "85 篇", desc: "热搜机制、舆论周期与传播规律" },
  { name: "细节深挖", icon: "ri-search-eye-fill", count: "57 篇", desc: "把被忽略的线索捡起来，逐条串成脉络" },
];

export const deepArticles: DeepArticle[] = [
  {
    id: "a1",
    category: "综艺幕后",
    title: "一档爆款真人秀的“剧本感”，到底从哪来",
    excerpt: "好的真人秀不是没有设计，而是把设计藏得足够深。我们从分镜、流程单到剪辑节奏，逐层拆解“戏剧张力”是如何被精确制造出来的。",
    author: "编辑部 · 阿瓜",
    date: "2026-09-04",
    readTime: "8 分钟",
    views: "38.6w",
    isFeatured: true,
    image:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20television%20studio%20control%20room%20with%20large%20monitor%20wall%2C%20director%20chairs%2C%20lighting%20rigs%20and%20timeline%20storyboard%20strips%20floating%20above%2C%20warm%20cream%20paper%20background%2C%20crimson%20and%20amber%20palette%2C%20ink%20linework%2C%20stylized%20no%20text&width=1200&height=800&seq=pick-studio-01&orientation=landscape",
    alt: "综艺幕后拆解插画：导播间与剪辑时间线",
  },
  {
    id: "a2",
    category: "舆论观察",
    title: "热搜榜第一，不等于事情最重要",
    excerpt: "一条话题为什么冲顶、又为什么迅速降温？我们用一周的数据追踪了三个案例，聊聊热度背后的排序逻辑与注意力游戏。",
    author: "编辑部 · 秋刀鱼",
    date: "2026-09-03",
    readTime: "7 分钟",
    views: "29.1w",
    isFeatured: true,
    image:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20towering%20ranking%20bar%20chart%20made%20of%20blocks%20with%20ascending%20and%20descending%20arrows%2C%20floating%20gauge%20and%20magnifier%2C%20warm%20cream%20background%2C%20crimson%20red%20and%20amber%20palette%2C%20ink%20outline%20style%2C%20artistic%20no%20text&width=1200&height=800&seq=pick-heat-01&orientation=landscape",
    alt: "热搜热度拆解插画：排名柱状与关注度曲线",
  },
  {
    id: "a3",
    category: "品牌瓜",
    title: "联名越火，翻车越响？一次合作的两份答卷",
    excerpt: "当两个品牌站上同一条起跑线，谁踩中情绪红利、谁被情绪反噬？我们用两份真实案例对照，拆解联名营销的边界在哪里。",
    author: "编辑部 · 周一",
    date: "2026-09-02",
    readTime: "6 分钟",
    views: "24.8w",
    isFeatured: true,
    image:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20two%20hands%20shaking%20over%20stacked%20gift%20boxes%20with%20bursting%20speech%20bubbles%2C%20one%20side%20rising%20and%20one%20side%20cracking%2C%20warm%20cream%20background%2C%20crimson%20and%20amber%20palette%2C%20ink%20linework%2C%20stylized%20no%20text&width=1200&height=800&seq=pick-brand-01&orientation=landscape",
    alt: "品牌联名复盘插画：握手与礼盒、情绪气泡",
  },
  {
    id: "a4",
    category: "直播热点",
    title: "三二一上链接之前，话术台本已经写好",
    excerpt: "从压价表演、库存倒计时到“最后一波”，我们把一场直播间从头到尾做了一次逐字复盘，看情绪是怎么被精确编排的。",
    author: "编辑部 · 柠檬水",
    date: "2026-09-01",
    readTime: "7 分钟",
    views: "19.6w",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20mobile%20phone%20screen%20with%20floating%20shopping%20cart%2C%20countdown%20clock%2C%20like%20hearts%20and%20price%20tags%2C%20shiny%20confetti%20around%2C%20warm%20cream%20background%2C%20crimson%20and%20amber%20palette%2C%20ink%20outline%20style%2C%20stylized%20no%20text&width=1200&height=800&seq=pick-live-01&orientation=landscape",
    alt: "直播话术复盘插画：手机屏幕、购物车与倒计时",
  },
  {
    id: "a5",
    category: "吃瓜指南",
    title: "吃瓜也要讲基本法：五步辨真假爆料",
    excerpt: "没有来源的截图、掐头去尾的录音、只有情绪没有证据的文案……这套五步清单，帮你在转发前多花六十秒。",
    author: "编辑部 · 理中客",
    date: "2026-08-30",
    readTime: "5 分钟",
    views: "14.2w",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20five%20step%20checklist%20with%20checkboxes%2C%20magnifying%20glass%2C%20shield%20icon%20and%20document%20sheets%20floating%2C%20warm%20cream%20background%2C%20crimson%20and%20amber%20palette%2C%20ink%20linework%2C%20clean%20stylized%20no%20text&width=1200&height=800&seq=pick-guide-01&orientation=landscape",
    alt: "吃瓜指南插画：验证清单与放大镜、盾牌",
  },
  {
    id: "a6",
    category: "细节深挖",
    title: "片场那点事：群演口中真实的一天",
    excerpt: "凌晨出工、反复走位、一场戏NG十几遍……当镜头只留给主角时，我们记录了群演视角下的真实片场日常。",
    author: "编辑部 · 老周",
    date: "2026-08-28",
    readTime: "6 分钟",
    views: "11.3w",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20film%20set%20scene%20with%20clapperboard%2C%20director%20monitor%2C%20folding%20chair%20and%20background%20crew%20silhouettes%20at%20dawn%2C%20warm%20cream%20background%2C%20crimson%20and%20amber%20palette%2C%20ink%20linework%2C%20stylized%20no%20text&width=1200&height=800&seq=pick-set-01&orientation=landscape",
    alt: "片场日常细节插画：场记板、监视器与晨光",
  },
];

export const timelineFeature = {
  eyebrow: "编辑部实验室",
  title: "一场爆料从出现到辟谣，到底经历了什么",
  intro:
    "我们虚构了一则“爆料”，用编辑部的工作流完整记录一条瓜从被抛出、被转发、被质疑到被澄清的全过程，帮你看懂每一次传播转折背后的关键动作。",
  nodes: [
    {
      phase: "第一阶段 · 出现",
      time: "第 1 天 08:00",
      content: "一条“知情人士”爆料出现在匿名社区，配上一张模糊截图。此时阅读量很小，但消息开始在不同群里小范围流动。",
      kind: "rumor" as const,
    },
    {
      phase: "第二阶段 · 发酵",
      time: "第 1 天 14:00",
      content: "营销号开始搬运，标题被不断放大。没有新增证据，但情绪性文案让转发量成倍上涨，话题冲上讨论区前排。",
      kind: "rumor" as const,
    },
    {
      phase: "第三阶段 · 质疑",
      time: "第 2 天 09:00",
      content: "有人发现截图存在明显的编辑痕迹，时间、账号对不上。第一批“打假帖”出现，舆论开始出现分歧。",
      kind: "fact" as const,
    },
    {
      phase: "第四阶段 · 澄清",
      time: "第 3 天 18:00",
      content: "当事人通过正规渠道给出回应，说明截图出处与时间线。真相虽迟到，但复盘依然有价值：哪一步让传言跑得更快？",
      kind: "guide" as const,
    },
  ],
  footnote: "提醒：本文用于方法科普，不指向任何真实人物或事件。理性吃瓜，别让第一印象替你做决定。",
};

export const storyBlock = {
  eyebrow: "编辑部特稿",
  title: "被折叠的细节，往往才是离真相最近的那一页",
  lead: "同一件事，为什么不同的人讲出来是两个版本？我们把一次普通的娱乐争议放回它的真实语境里，看看那些被舆论折叠掉的细节。",
  body: [
    "争议刚上热搜时，大多数人只看到两句互相矛盾的发言。可当我们把时间线拉长，把完整的上下文拼回来，才发现双方真正分歧的从来不是那两句话本身，而是对同一段事实的“剪辑方式”。",
    "一段被掐掉开头结尾的录音、一句脱离语境的回应、一张没有出处的截图——单独看都足够有冲击力，合起来却经不起推敲。编辑部的方法很简单：先收集，再排序，最后才表态。",
    "在信息爆炸的时代，慢一点反而是一种稀缺能力。我们不鼓励把热度当真理，也反对在没有依据时急于下结论。与其跟着情绪走，不如先问三个问题：来源是谁？证据在哪？还缺了什么？",
  ],
  pullquote: "与其跟着情绪走，不如先问三个问题：来源是谁？证据在哪？还缺了什么？",
  image:
    "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20a%20stacked%20collage%20of%20newspaper%20clippings%2C%20magnifying%20glass%2C%20unfolding%20folded%20paper%20revealing%20hidden%20lines%2C%20question%20marks%20dissolving%20into%20clarity%2C%20warm%20cream%20background%2C%20crimson%20and%20amber%20palette%2C%20ink%20linework%2C%20stylized%20no%20text&width=900&height=1100&seq=story-portrait-01&orientation=portrait",
  alt: "编辑部特稿插画：折叠报纸与放大镜揭示隐藏细节",
};

export const faqs: Faq[] = [
  {
    q: "看吃瓜的内容会和其它营销号一样只搬运标题吗？",
    a: "不会。我们把“来源追溯、上下文还原、细节核对”作为每篇深扒的基本动作，坚持用编辑部视角给出有依据的拆解，而不是单纯堆叠情绪化标题。每一篇稿件都经过资料整理与交叉核对后才会发布。",
  },
  {
    q: "你们的爆料信息可靠吗？如何处理真假难辨的消息？",
    a: "我们会给每条关键信息标注可信等级：有公开出处、多方印证的消息会明确呈现；只有单一来源或无法证实的传闻，会用“存疑”标注并在正文中提示读者审慎看待，绝不把猜测伪装成事实。",
  },
  {
    q: "如果内容里有错误或争议，可以申请修正吗？",
    a: "可以。你在文章底部或通过编辑部邮箱提出异议后，我们会启动复核流程：核对原始资料、确认出入后及时修正，并在相关文章内更新勘误说明，让信息保持可追溯和可纠错。",
  },
  {
    q: "如何订阅看吃瓜的更新，不错过重点内容？",
    a: "你可以在首页底部填写邮箱订阅“看吃瓜周报”，我们每周精选当期最有价值的深扒与事件脉络汇总发送；也可以关注网站的栏目页，按“综艺幕后”“舆论观察”等主题定向追更。",
  },
  {
    q: "我能投稿爆料或者提供线索吗？",
    a: "当然欢迎。你可以通过页脚的编辑部邮箱发送线索，尽量附带来源、时间与可核实的信息。我们会评估线索价值，并承诺不公开未经你同意的身份信息，用审慎的态度对待每一份线索。",
  },
];

export const readerNotes: ReaderNote[] = [
  {
    name: "橘子汽水",
    role: "追更 2 年 · 综艺党",
    text: "第一次看到有人把真人秀的剪辑逻辑拆得这么清楚，原来“剧本感”不是玄学。看完会下意识去看镜头怎么给、字幕怎么打，回不去了。",
  },
  {
    name: "莫小北",
    role: "新媒体从业者",
    text: "那些“热搜为什么这样排”“营销怎么翻车”的文章给了我很多写作灵感。专业但不端着，能讲清楚又不掉书袋，很难得。",
  },
  {
    name: "阿七",
    role: "吃瓜入门选手",
    text: "最喜欢吃瓜指南栏目，现在转发前会先问自己来源是谁、证据在哪。看吃瓜没有让我更八卦，反而让我更冷静了。",
  },
];

export const stats = [
  { value: "500+", label: "深度稿件" },
  { value: "1200w+", label: "累计阅读" },
  { value: "36", label: "个主题栏目" },
  { value: "92%", label: "内容溯源率" },
];

export const footerNav = {
  about: ["关于看吃瓜", "编辑部理念", "内容原则", "联系方式"],
  columns: ["综艺幕后", "幕后真相", "品牌瓜", "直播热点", "舆论观察", "细节深挖"],
  service: ["订阅周报", "投稿爆料", "合作联系", "隐私与纠错"],
};